export const planResults = async (endPoint: string, zip: string, fips: string, year: number) => {
  const uri = `?action=plan-search&zip=${zip}&year=${year}&fips=${fips}&planType=7`;

  const controller = new AbortController();
  const terminateEarly = setTimeout(() => controller.abort(), 20000);

  const response = await fetch(`${endPoint}${uri}`, {
    method: 'GET',
    signal: controller.signal,
  });
  clearTimeout(terminateEarly);
  if (!response.ok) {
    throw new Error('planSearch call - response was not OK');
  }
  return await response.json();
};

export default planResults;
